import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";

import LandingCarousel from "../components/LandingCarousel";
import AboutUs from "../components/AboutUs";
import Events from "../components/Events";
import Projects from "../components/LandingProjects";
import Footer from "../components/Footer";
import MenuItems from "../components/MenuItems";

import * as CONSTANTS from "../assets/Constants";
// import LANDING_IMAGE from "../assets/images/team3.jpg";

const getWidth = () => {
  const isSSR = typeof window === "undefined";
  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

let displayRecruitment = CONSTANTS.displayRecruitment;

class DesktopNav extends Component {
  constructor(props) {
    super(props);
    this.aboutRef = React.createRef();
  }

  scrollToAboutRef = () => {
    if (this.aboutStart) this.aboutStart.scrollIntoView({ behavior: "smooth" });
  };

  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            style={{
              minHeight: 660,
              // THE PLACE TO ADD LANDING IMAGE AS BACKGROUND
              // backgroundImage: "url(" + LANDING_IMAGE + ")"
              backgroundColor: "#111111"
            }}
            vertical
          >
            >
            <Container textAlign="center" vertical="true">
              <Menu
                fixed={fixed ? "top" : null}
                inverted={!fixed}
                pointing={!fixed}
                secondary={!fixed}
                size="large"
              >
                <MenuItems
                  fixed={fixed}
                  activeItem="home"
                  displayRecruitment={displayRecruitment}
                />
              </Menu>
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column textAlign="left" width={6}>
                    <Segment vertical>
                      <br />
                      <br />
                      <br />
                      <Header as="h2" inverted style={{ fontSize: "2em" }}>
                        Welcome!
                      </Header>
                      <Header
                        as="h3"
                        inverted
                        textAlign="left"
                        style={{ fontSize: "1.3em" }}
                      >
                        We are from Robotics Club @ SASTRA, one of tech clubs at
                        SASTRA University, Thanjavur. Our club is full of DIY
                        enthusiasts who take up projects and challenges from
                        fields like Robotics, IoT, 3D Printing, Computer Vision,
                        Machine Learning and many more…..
                      </Header>
                    </Segment>
                  </Grid.Column>

                  <Grid.Column
                    floated="right"
                    width={9}
                    style={{ minHeight: 450, padding: "1em 0em" }}
                    verticalAlign="middle"
                  >
                    <LandingCarousel />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column textAlign="center">
                    <Button
                      size="large"
                      onClick={this.scrollToAboutRef}
                      animated
                    >
                      <Button.Content visible>
                        Learn more about us
                      </Button.Content>
                      <Button.Content hidden>
                        About Us
                        <Icon name="arrow down" />
                      </Button.Content>
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Segment>
          <Segment style={{ padding: "8em 0em" }} vertical>
            <div
              style={{ float: "left", clear: "both" }}
              ref={el => {
                this.aboutStart = el;
              }}
            />
            <AboutUs />
          </Segment>
        </Visibility>
        {children}
      </Responsive>
    );
  }
}

DesktopNav.propTypes = {
  children: PropTypes.node
};

class MobileNav extends Component {
  constructor(props) {
    super(props);
    this.aboutRef = React.createRef();
  }

  scrollToAboutRef = () => {
    if (this.aboutStart) this.aboutStart.scrollIntoView({ behavior: "smooth" });
  };

  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <MenuItems
            fixed={false}
            activeItem="home"
            displayRecruitment={displayRecruitment}
          />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{
              minHeight: 350,
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size="large">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                  {/* <Image src={LOGO} size="mini" /> */}
                </Menu.Item>
                <Menu.Item position="right">
                  <Button as="a" href="#/login" inverted>
                    Log in
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <div>
              <Segment
                style={{
                  backgroundColor: "#111111"
                }}
                vertical
              >
                >
                <Container
                  inverted="true"
                  textAlign="center"
                  style={{
                    backgroundColor: "#111111"
                  }}
                  vertical="true"
                >
                  <Grid columns="equal" stackable verticalAlign="middle">
                    <Grid.Row>
                      <Grid.Column textAlign="left">
                        <Header as="h2" inverted style={{ fontSize: "2em" }}>
                          Welcome!
                        </Header>
                        <Header
                          as="h3"
                          inverted
                          textAlign="left"
                          style={{ fontSize: "1.3em" }}
                        >
                          We are from Robotics Club @ SASTRA, one of tech clubs
                          at SASTRA University, Thanjavur. Our club is full of
                          DIY enthusiasts who take up projects and challenges
                          from fields like Robotics, IoT, 3D Printing, Computer
                          Vision, Machine Learning and many more…..
                        </Header>
                      </Grid.Column>
                      <Grid.Column floated="right">
                        <LandingCarousel />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column textAlign="center">
                        <Button
                          size="large"
                          onClick={this.scrollToAboutRef}
                          animated
                        >
                          <Button.Content visible>
                            Learn more about us
                          </Button.Content>
                          <Button.Content hidden>
                            About Us
                            <Icon name="arrow right" />
                          </Button.Content>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Container>
              </Segment>
            </div>
          </Segment>
          <Segment style={{ padding: "8em 0em" }} vertical>
            <div
              style={{ float: "left", clear: "both" }}
              ref={el => {
                this.aboutStart = el;
              }}
            />
            <AboutUs />
          </Segment>
          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileNav.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopNav>{children}</DesktopNav>
    <MobileNav>{children}</MobileNav>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

const Landing = () => (
  <ResponsiveContainer>
    <Events />
    <Projects />
    <Footer />
  </ResponsiveContainer>
);

export default Landing;
